import { render, staticRenderFns } from "./NewsLanding.vue?vue&type=template&id=6b44b70b&scoped=true&"
import script from "./NewsLanding.vue?vue&type=script&lang=js&"
export * from "./NewsLanding.vue?vue&type=script&lang=js&"
import style0 from "./NewsLanding.vue?vue&type=style&index=0&id=6b44b70b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44b70b",
  null
  
)

export default component.exports